import React from 'react';

const Landing = () => (
  <div>
    <h1>Attest Report</h1>
  </div>
);

export default Landing;
